import { render, staticRenderFns } from "./ExpenseSettingDetails.vue?vue&type=template&id=796b1613&scoped=true&"
import script from "./ExpenseSettingDetails.vue?vue&type=script&lang=js&"
export * from "./ExpenseSettingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSettingDetails.vue?vue&type=style&index=0&id=796b1613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b1613",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VIcon,VRow})
